import React, { useEffect, createElement } from 'react';
import { CountdownBar } from './components/CountdownBar';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { TomoCards } from './components/TomoCards';
import { KitContents } from './components/KitContents';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { HowToReceive } from './components/HowToReceive';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { FooterSection } from './components/FooterSection';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    const pixelId = '757545003709827';
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const f = window as any;
      const n = (f.fbq = function (...args: any[]) {
        if (n.callMethod) {
          n.callMethod.apply(n, args);
        } else {
          n.queue.push(args);
        }
      }) as any;
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      } else {
        document.head.appendChild(script);
      }
      f.fbq('init', pixelId);
      f.fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen font-sans text-gray-900 bg-white" data-id="element-0">
      <CountdownBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <PainSection data-id="element-3" />
      <SolutionSection data-id="element-4" />
      <TomoCards data-id="element-5" />
      <KitContents data-id="element-6" />
      <BonusSection data-id="element-7" />
      <PricingSection data-id="element-8" />
      <HowToReceive data-id="element-9" />
      <GuaranteeSection data-id="element-10" />
      <TestimonialsSection data-id="element-11" />
      <FAQSection data-id="element-12" />
      <PricingSection data-id="element-13" />
      <FooterSection data-id="element-14" />
      <SocialProofPopup data-id="element-15" />
    </div>;
}